<app-registration-process *ngIf="english"></app-registration-process>
<app-registration-process-hindi *ngIf="hindi"></app-registration-process-hindi>